/** REST base path for positions on an offering (Phase 3). */
export function offeringPositionsApiBase(offeringId: string): string {
  return `/api/offerings/${encodeURIComponent(offeringId)}/positions`;
}
